import React from 'react';

import useChangeEffect from 'coreHooks/useChangeEffect';

type IContainerProps = {
	id: string;
	callback: string;
};

const Container = ({id, callback}: IContainerProps) => {
	// The CMS script fills the container once: not again at every render of the page (it would add its content
	// again), nor when a page kept alive (`<Activity>`) is shown again with the container still filled.
	useChangeEffect(() => {
		if (callback) {
			try {
				eval(callback);
			} catch (e) {} // eslint-disable-line no-empty
		}
	}, [id, callback], true);

	return <div id={id} />;
};

export default Container;
